export default "__VITE_ASSET__ZOTcItkU__"